export const OPT_OUT_EVENT = "RCB/OptOut";
